import styled from 'styled-components';
import { StyledAdminListHeaders } from '../../AdminListHeaderCell/styles/StyledAdminListHeaders';

export const StyledAdminGroupPoolConfigsListHeader = styled.div`
  ${StyledAdminListHeaders}

  .admin-list-header-cell-container {
    &.id,
    &.priority,
    &.port,
    &.algorithm,
    &.maxattempts,
    &.actions,
    &.order {
      flex-basis: initial;
      flex-grow: 0;
    }

    &.id,
    &.priority {
      width: 10.4rem;
    }

    &.actions {
      width: 10.8rem;

      @media (min-width: 768px) and (max-width: 1440px) {
        width: 8.8rem;
      }
    }

    &.order {
      width: 7.8rem;

      @media (min-width: 768px) and (max-width: 1440px) {
        width: 6.8rem;
      }
    }

    &.port,
    &.algorithm,
    &.maxattempts {
      width: 14.4rem;
    }
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }
`;
